import { createContext, useContext, useState, useCallback } from "react";

const BreadcrumbContext = createContext({
  dynamicTitles: {},
  setDynamicTitle: () => {},
});

export function BreadcrumbProvider({ children }) {
  const [dynamicTitles, setDynamicTitles] = useState({});

  const setDynamicTitle = useCallback((key, title) => {
    setDynamicTitles((prev) => {
      if (prev[key] === title) return prev;
      return { ...prev, [key]: title };
    });
  }, []);

  return (
    <BreadcrumbContext.Provider value={{ dynamicTitles, setDynamicTitle }}>
      {children}
    </BreadcrumbContext.Provider>
  );
}

export function useBreadcrumbContext() {
  return useContext(BreadcrumbContext);
}
